export default __webpack_public_path__ + "static/media/audioToAnimal.8d514a0f.png";